import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { LogIn } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={location.state?.from || "/"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try { await login(email, password); navigate(location.state?.from || "/", { replace: true }); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F5EFE4] flex items-center justify-center p-5" data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-8 shadow-xl shadow-amber-900/10">
        <Logo className="text-[34px] mb-8" subtitle="Üretim Paneli" />
        <div className="space-y-4">
          <div>
            <Label className="text-xs text-[#6B5B4A]">E-posta</Label>
            <Input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required
              data-testid="login-email" className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
          <div>
            <Label className="text-xs text-[#6B5B4A]">Şifre</Label>
            <Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required
              data-testid="login-password" className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
          {error && <p className="text-sm text-[#B91C1C]" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="login-submit"
            className="w-full h-11 bg-[#D97706] hover:bg-[#B45309] text-white font-display uppercase tracking-wide">
            <LogIn className="w-4 h-4 mr-2" /> {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>
        </div>
      </form>
    </div>
  );
}
